import { render, staticRenderFns } from "./WebPageHeader.vue?vue&type=template&id=3d521fb7&scoped=true"
import script from "./WebPageHeader.vue?vue&type=script&lang=js"
export * from "./WebPageHeader.vue?vue&type=script&lang=js"
import style0 from "./WebPageHeader.vue?vue&type=style&index=0&id=3d521fb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d521fb7",
  null
  
)

export default component.exports